import { useQueryClient } from "@tanstack/react-query"

export const taskTemplateKeys = {
  all() {
    return ["task-automations"] as const
  },

  taskAutomations() {
    return [...this.all(), "list"] as const
  },
} as const

export function useTaskAutomationCache() {
  const queryClient = useQueryClient()

  function invalidateTaskAutomations() {
    const cacheKey = taskTemplateKeys.taskAutomations()

    return queryClient.invalidateQueries({
      queryKey: cacheKey,
    })
  }

  return {
    invalidateTaskAutomations,
  }
}
